<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_company.edit_company')">
    <template #content>
      <v-container class="edit-company-content" fluid v-if="company">
        <v-form ref="companyForm">
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_company.name_en')"
                            v-model="company.name_en"
                            clearable
                            :rules="requiredRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_company.name_zh')"
                            v-model="company.name_zh"
                            clearable
                            :rules="requiredRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_company.disabled')"
                            :value="company.disabled ? 'Yes' : 'No'"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               v-if="tabIndex === 0"
               @click="$refs.companyForm.validate() && saveCompany()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";

export default {
  name: 'EditCompanyModal',
  components: {BGModal},
  props: {
    shown: Boolean,
    companyId: String,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    const tabIndex = ref(0);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          tabIndex.value = 0;
          getCompany();
        }
      }

      tabIndex.value = 0;
    });
    const cancel = function () {
      emit('cancel');
    };
    const getCompany = function () {
      root.$callAPI('hkiarace/admin/company/', {id: props.companyId}, function (response) {
        company.value = response.body.company;
      });
    }

    // Info
    const company = ref(null);

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const saveCompany = function () {
      root.$callAPI('hkiarace/admin/company/edit/', {
        ...company.value,
      }, () => {
        root.$showAlertMessage('Info Saved');
        getCompany();
      })
    }

    return {
      dialogShown,
      tabIndex,

      cancel,

      // Info
      company,

      requiredRules,

      saveCompany,
    }
  }
}
</script>

<style lang="less">
.edit-company-content {
  display: flex;
  height: 100%;
  flex-direction: column;
}
</style>
